history.scrollRestoration = 'manual';
$('.card-wrapper[href]').click(function(){
       var hrefs=$(this).attr('href');
       window.location.href=hrefs
     })
$('tr[itemid="40835414786153"] cart-remove-button .button').click(function(){

setTimeout(function(){
  window.location.href='/cart';
},1500)
})
if($('body.cart').length){
setInterval(function(){
  $('.cart__items tr[itemid="40835414786153"]').find('td.cart-item__details').css('pointer-events','none')
   $('.cart__items tr[itemid="40835414786153"]').find('td.cart-item__quantity quantity-input.quantity').css('pointer-events','none')
},100)
  
}
$('.add-crt-ffer').click(function(){
var gts=$('.sizelist  li.active').attr('size');

  var gtsclr=$('.clr--area .back-color.active').attr('clr');
 
 data = {
      "id": 40835414786153,
      "quantity": 1,
      "properties": {
        "Size": gts,
        "Color": gtsclr
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }

})
})
         $('.size-div ul li').click(function(){
$('.size-div ul li').removeClass('active');
           $(this).addClass('active')

         })
$('.clr--area .back-color').click(function(){
$('.clr--area .back-color').removeClass('active');
           $(this).addClass('active')

         })
if($(window).width() < 1050){
     $('.all-insta-posts').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
   infinite:true
 })
     
     $('.mnu-rws .footer-col:first-child').find('.headingft').trigger('click');
 if($('.boxplusbutton').length){
  setTimeout(function(){
    var gtheight= $('.new--fixed').height();
   $('.new--fixed').css('height',gtheight+'px')
  },1000)

  var distance = $('.boxplusbutton').offset().top,
    $window = $(window);

$window.scroll(function() {
    if ( $window.scrollTop() >= distance ) {
        $('body').addClass('topwindow')
    }else{
      $('body').removeClass('topwindow')
    }
});
 }
   }
$('.mnu-rws .footer-col p.headingft').click(function(){

if($(this).hasClass('active')){
$('.mnu-rws .footer-col p.headingft').removeClass('active');
  $('.mnu-rws ul.menu').slideUp();
}else{

$('.mnu-rws .footer-col p.headingft').removeClass('active');
  $('.mnu-rws ul.menu').slideUp();

  $(this).addClass('active');
  $(this).next('ul.menu').slideDown();
}

  
})
var totalchar = 25;
         $('textarea#Cart-note').keydown(function () {

$('textarea#Cart-note').attr('maxlength','25')


           
            var leftchars = totalchar - $(this).val().length;
            $('.remaining').text(leftchars);
         });

$('.movelink').click(function(){
 var href= $(this).attr('href');
  window.location.href=href;
})
$('.filtr--blogs.desktop--hide').click(function(){

$('body').addClass('showfiltr')
  
})

$("body.index").on("click",".banner-details.mvimage", function(e){
var clickable=$(this).attr('clickable');
  window.location.href=clickable

})
   $("body.blog").on("click","ul.list--inline.pagination li a", function(e){
     
     
   
e.preventDefault();

      $('html, body').animate({
        scrollTop: $(".Blog--list---wrp").offset().top
    }, 100);
     var hr=$(this).attr('href');
      $.ajax({
type: "GET",
url: hr,
    success: function(response){
       
var gst=$(response);
     var geths=gst.find('.blog--list--imaggrid').html()
      $('.blog--list--imaggrid').html(geths)
      setTimeout(function(){
        
     BackgroundLazyLoader();
      
       
      },800)
     }
  })

   })
// function dateSlry(){

//   $(".blog-grid-row li.blog-grid ").sort(sort_li).appendTo('.blog-grid-row');
//   function sort_li(a, b) {
//     return ($(a).data('position')) < ($(b).data('position')) ? 1 : -1;
//   }

// }


//  if($(window).width() < 767 ){
//  $(".blog-grid-row li").slice(5, 19).remove();
//    $('.blog-grid-row  li.last--slid-blog').remove();
//   var gtlst= $('.allblog--link').html();

//     $(".blog-grid-row").append(gtlst)
//    }
  $("body").on("click",".blog--img--grid", function(){
  var hrf=$(this).attr('href');
window.location.href=hrf
})
$(window).on('load', function() {
   setTimeout(function(){

 

        
$('body').addClass('full_Bodyloaded')
   },800)
});
$('.blog--list--sidebar span.cross-filtr svg').click(function(){
  $('body').removeClass('showfiltr')
})
  $("body").on("click","h3.mobile--heading-tlt", function(){
if($(this).hasClass('active')){
   $('h3.mobile--heading-tlt').removeClass('active');
  $('.faq--text ul li').removeClass('active');
  $('.conetne--area--faq').slideUp();
   $('ul.slider--location').slideUp();
}else{
  $('h3.mobile--heading-tlt').removeClass('active');
  $(this).addClass('active');
    $('.conetne--area--faq').slideUp();
  $('ul.slider--location').slideUp();
  $(this).next('ul.slider--location').slideDown();
}


  })


  $("body").on("click",".remove--knife", function(){
  var acves=$('ul.steps--all-knives li.active').index();
    $('ul.steps--all-knives li.active').remove();
  var hyst=acves+1
      $('.all--knifes-apend').slick('unslick');
  $('.all--knifes-apend .knife--item').eq(acves).remove();
  
      $('.all--knifes-apend').addClass('loading--slck');
   $('.all--knifes-apend').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
   swipe: false,
   infinite:false,
      arrows:false,
   draggable: false,
 })
    var i=1;
     setTimeout(function(){
      $('ul.steps--all-knives li').each(function(){
         $(this).text('Knife '+i);
         i++;
       })
    var j=1
$('.nmbring--knif ul.steps--all-knives li').each(function(){
         $(this).text(j);
         j++;
       })


       
       $('ul.steps--all-knives li:nth-child(1)').addClass('active')
 $('.all--knifes-apend').slick('slickGoTo', 0);
  $('.all--knifes-apend ').removeClass('loading--slck')  
       var getlilnt=$('ul.steps--all-knives li').length
      if(getlilnt==1){ 
$('.remove--knife').attr('crnt','1')
      }
},1000)
    
    
  
})


$('.upload--files .file--uplload-im').on('drag dragstart dragend dragover dragenter dragleave drop', function(event) {
			event.preventDefault();
			event.stopPropagation();
		}).on('dragover dragenter', function() {
			$('body').addClass('is-dragover');
		}).on('dragleave dragend drop', function() {
			$('body').removeClass('is-dragover');
		}).on('drop', function(event) {
			
     
			$('.upload--files .file--uplload-im input[type=file]').prop('files', event.originalEvent.dataTransfer.files);
           $('.upload--files .file--uplload-im input[type=file]').trigger('change');
		});




$('.upload--files .file--uplload-im input[type=file]').change(function() {

       var filename = $('.upload--files .file--uplload-im input[type=file]').val().split('\\').pop();
    
        var lastIndex = filename.lastIndexOf("\\");   
        $('span.drag--fields').text(filename);
    });
     




$("body").on("click",".radio_sec ul li", function(){

if($(this).hasClass('active')){
  
}else{
  var txt=$(this).text();
  $('.radio_sec ul li').removeClass('active');
  $(this).addClass('active');
  var locationid=$(this).attr('locationid');
  $('.faq--answer .faq--text ul.slider--location').hide();
  $('.faq--answer .faq--text ul.slider--location[tbs='+locationid+']').slideDown()
  $('h1.gnral--title').text(txt);
  $('.active--cartgry').text(txt);
}
 })

  $("body").on("click",".active--cartgry", function(){

$(this).toggleClass('active');
    $(".category_wrp .faq--question ul").slideToggle("slow");
  })

    $("body").on("click",".title---faq", function(){
    if($(this).parent('li').hasClass('active')){
      $('.faq--text ul li').removeClass('active');
      $('.conetne--area--faq').slideUp();
    }else{
$('.faq--text ul li').removeClass('active');
      $('.conetne--area--faq').slideUp();
      $(this).parent('li').addClass('active');
      $(this).parent('li').find('.conetne--area--faq').slideDown();
    }
  })

  $('.radio_sec a').click(function(e){
    e.preventDefault()
  })




  $(".radio_sec ul li").click(function() {
      if($(window).width() < 767 ){
    $('html, body').animate({
        scrollTop: $(".faq--answer").offset().top
    }, 100);
      }
  });


function focustosearch(){
document.getElementById("Search-In-Modal").focus();



}

$(window).on('load', function() {
setTimeout(function(){
  $('.collection--featured-col ul.grid .grid__item').each(function(){

    var getoks=$(this).find('.okeReviews-reviewsSummary-starRating span.okeReviews-a11yText').text().replace('out of 5','').replace('Rated','');
    $(this).find('.okeReviews-reviewsSummary.js-okeReviews-reviewsSummary .okeReviews-reviewsSummary-starRating').append('<p class="ratingMbrs">'+getoks +'</p>')

  })
},1000)
});

if($(window).width() < 767 ){
  


$('ul.blog-grid-row').slick({
   slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
         dots:true,
  
          responsive: [
    {
      breakpoint: 999999,
      settings: {
       slidesToShow: 3,
  slidesToScroll: 1
      }
    },{
      
      breakpoint: 767,
      settings: {
        
        slidesToShow: 1,
  slidesToScroll: 1
      }
    }
            ]
       })
$("ul.blog-grid-row").on("beforeChange", function (){
    setTimeout(function(){
      var slidnmbr=Number($('ul.blog-grid-row .slick-dots li.slick-active').index());
      var lstside=Number($('ul.blog-grid-row ul.slick-dots li').length);
      
     var newslidnmbr=slidnmbr+1;
       var dstce= newslidnmbr*100/lstside;
      
      var dstce=100-dstce;
       var dstce=dstce+'%';

       var slidnmbr=$('ul.blog-grid-row.slick-slide.slick-current.slick-active').attr('slidnmbr');
      // $('.slick-counter span').text(slidnmbr);
    imgLoaded1(dstce)
    
    },10)
})


 function imgLoaded1(dstce) {
    
$('ul.blog-grid-row ul.slick-dots p').css({'left':dstce})
}
setTimeout(function(){
    
            
    var lstside=Number($('ul.blog-grid-row ul.slick-dots li').length);
    
    
    var dstces= 100/lstside;
    var dstce= dstces+'%';
      var leftsd=100-dstces;
       var leftsd=leftsd+'%';

    $('ul.blog-grid-row ul.slick-dots').append('<p></p>')
     $('ul.blog-grid-row ul.slick-dots p').css({'width':dstce})
    $('ul.blog-grid-row ul.slick-dots p').css({'left':leftsd})
  },2000)



}


 var topmbnr=document.getElementById("top--announcement");
  if(topmbnr){
    var activebodyh = document.querySelector('body');
   activebodyh.classList.toggle("TopBar_Active");
  }
  var faqntppro=document.querySelector(".faqntppro");

if(faqntppro){
$('.faq-slider.faqntppro .faq---items').slick({
   slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
         dots:true,
  
          responsive: [
    {
      breakpoint: 999999,
      settings: {
       slidesToShow: 3,
  slidesToScroll: 1
      }
    },{
      
      breakpoint: 767,
      settings: {
        
        slidesToShow: 1,
  slidesToScroll: 1
      }
    }
            ]
       })
$(".faq-slider.faqntppro .faq---items").on("beforeChange", function (){
    setTimeout(function(){
      var slidnmbr=Number($('.faq-slider .slick-dots li.slick-active').index());
      var lstside=Number($('.faq-slider ul.slick-dots li').length);
      
     var newslidnmbr=slidnmbr+1;
       var dstce= newslidnmbr*100/lstside;
      
      var dstce=100-dstce;
       var dstce=dstce+'%';

       var slidnmbr=$('.items--faq-lps.slick-slide.slick-current.slick-active').attr('slidnmbr');
      // $('.slick-counter span').text(slidnmbr);
    imgLoaded(dstce)
    
    },10)
})
}
  function imgLoaded(dstce) {
    
$('.faq-slider ul.slick-dots p').css({'left':dstce})
}
setTimeout(function(){
    
            
    var lstside=Number($('.faq-slider ul.slick-dots li').length);
     
     // $('<div class="slick-counter"><span>1</span> / '+lstside+' </div>').insertAfter(".faq-slider ul.slick-dots");
    var dstces= 100/lstside;
    var dstce= dstces+'%';
      var leftsd=100-dstces;
       var leftsd=leftsd+'%';

    $('.faq-slider ul.slick-dots').append('<p></p>')
     $('.faq-slider ul.slick-dots p').css({'width':dstce})
    $('.faq-slider ul.slick-dots p').css({'left':leftsd})
  },2000)
var deleteLink = document.querySelector('.searc---icon-header');
var activesearch = document.querySelector('.custom-search');
var activebodyh = document.querySelector('body');

if (deleteLink && activesearch && activebodyh) {

  deleteLink.addEventListener('click', function(event) {

    setTimeout(function(){

      if (window.innerWidth > 1050){
        activebodyh.classList.toggle("active--body");
      } else {
        activebodyh.classList.toggle("mobileactive--body");
      }

    },300);

    activesearch.classList.toggle("active-Search");

  });

}



window.onload = function () { 
var heightscren =window.innerHeight;
      
      
    var getBar=document.getElementById("shopify-section-announcement-bar").offsetHeight;
      var gethead=document.getElementById("shopify-section-header").offsetHeight;
      var heighlast=heightscren-(getBar+gethead);

  var mbnr=document.getElementById("main--banner");
  var mslidr=document.querySelector(".slider-slick");
  
 
  if(mslidr){
     var heinew=heighlast-100;
    $('.banner-slider img').addClass('lazyload')
     document.querySelector(".slider-slick").style.height=heighlast+'px'
    $('.slider-slick').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
      infinite:true,
      arrows:true ,
      dots:true,
        prevArrow:"<div class='prev-nxt-btn slick-prev slick-arrow'><svg width='66' height='49' viewBox='0 0 66 49' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='-0.5' y='0.5' width='65' height='48' transform='matrix(-1 0 0 1 65 0)' fill='black' fill-opacity='0.2' stroke='white'/> <path d='M27.2923 17.2935C27.6826 16.9026 28.3157 16.9021 28.7065 17.2923C29.0974 17.6826 29.0979 18.3157 28.7077 18.7065L27.2923 17.2935ZM22 24.0095L21.2935 24.7171L20.5858 24.0106L21.2923 23.3029L22 24.0095ZM28.7065 29.2923C29.0974 29.6825 29.0979 30.3157 28.7077 30.7065C28.3175 31.0974 27.6843 31.0979 27.2935 30.7077L28.7065 29.2923ZM23 23L44 23L44 25L23 25V23ZM28.7077 18.7065L22.7077 24.716L21.2923 23.3029L27.2923 17.2935L28.7077 18.7065ZM22.7065 23.3018L28.7065 29.2923L27.2935 30.7077L21.2935 24.7171L22.7065 23.3018Z' fill='white'/> </svg></div>",
        nextArrow:"<div class='prev-nxt-btn slick-next slick-arrow'><svg width='66' height='49' viewBox='0 0 66 49' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.5' width='65' height='48' fill='black' fill-opacity='0.2' stroke='white'/> <path d='M38.7077 17.2935C38.3174 16.9026 37.6843 16.9021 37.2935 17.2923C36.9026 17.6826 36.9021 18.3157 37.2923 18.7065L38.7077 17.2935ZM44 24.0095L44.7065 24.7171L45.4142 24.0106L44.7077 23.3029L44 24.0095ZM37.2935 29.2923C36.9026 29.6825 36.9021 30.3157 37.2923 30.7065C37.6825 31.0974 38.3157 31.0979 38.7065 30.7077L37.2935 29.2923ZM43 23L22 23L22 25L43 25V23ZM37.2923 18.7065L43.2923 24.716L44.7077 23.3029L38.7077 17.2935L37.2923 18.7065ZM43.2935 23.3018L37.2935 29.2923L38.7065 30.7077L44.7065 24.7171L43.2935 23.3018Z' fill='white'/> </svg></div>",
      responsive: [
    {
      
      breakpoint: 1050,
      settings: {
        
          prevArrow:"<div class='prev-nxt-btn slick-prev slick-arrow'><svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='-0.5' y='0.5' width='29' height='29' transform='matrix(-1 0 0 1 29 0)' fill='black' fill-opacity='0.2' stroke='white'/> <path d='M10.4551 14.7273L20.0005 14.7273' stroke='white' stroke-width='1.21212' stroke-miterlimit='10'/> <path d='M12.7273 12L10 14.7316L12.7273 17.4545' stroke='white' stroke-width='1.21212' stroke-miterlimit='10' stroke-linecap='round'/> </svg></div>",
        nextArrow:"<div class='prev-nxt-btn slick-next slick-arrow'><svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.5' width='29' height='29' fill='black' fill-opacity='0.2' stroke='white'/> <path d='M19.5449 14.7273L9.99947 14.7273' stroke='white' stroke-width='1.21212' stroke-miterlimit='10'/> <path d='M17.2727 12L20 14.7316L17.2727 17.4545' stroke='white' stroke-width='1.21212' stroke-miterlimit='10' stroke-linecap='round'/> </svg></div>"
    
      }
    }
            ]
    })
    var gtli=Number($('.slider-slick ul.slick-dots li').length);
 var widli=100/gtli;
    $('.slider-slick ul.slick-dots li').css('width',widli+'%')
   if($('.topslideer-banner').hasClass('withdots')){}else{
     setTimeout(function(){
      
      var lstside=Number($('.topslideer-banner ul.slick-dots li').length);
     
     $('<div class="slick-counter"><span>1</span> / '+lstside+' </div>').insertAfter(".topslideer-banner ul.slick-dots");
    var dstces= 100/lstside;
    var dstce= dstces+'%';
      var leftsd=100-dstces;
       var leftsd=leftsd+'%';

    $('.topslideer-banner ul.slick-dots').append('<p></p>');
      $('.topslideer-banner ul.slick-dots').css({'top':heighlast+'px'})
    $('.topslideer-banner ul.slick-dots p').css({'width':dstce})
    $('.topslideer-banner ul.slick-dots p').css({'left':leftsd})
    },200)
  
  $(".topslideer-banner").on("beforeChange", function (){
    setTimeout(function(){
      var slidnmbr=Number($('.topslideer-banner .slick-dots li.slick-active').index());
      var lstside=Number($('.topslideer-banner ul.slick-dots li').length);
      
     var newslidnmbr=slidnmbr+1;
       var dstce= newslidnmbr*100/lstside;
      
      var dstce=100-dstce;
       var dstce=dstce+'%';
    
    imgLoaded(dstce)
    
    },10)
})
   }
  function imgLoaded(dstce) {
    
$('.topslideer-banner ul.slick-dots p').css({'left':dstce})
}
  }else if(mbnr){
      document.getElementById("main--banner").style.height=heighlast+'px'
  }
  setTimeout(function(){
    
    var gtsrc= document.getElementById("klvitisrc");
    if(gtsrc){
       var klvitisrc=document.getElementById("klvitisrc").getAttribute('dsrc');
  
   document.getElementById("klvitisrc").setAttribute("src", klvitisrc);
      
    } 
    
     var sliderLSt=document.getElementById("slider-list");
    if(sliderLSt){
      
      $('#slider-list .article-slider').each(function(){
      
    var aftrload= $(this).attr('aftrload');
        $(this).css('background-image', 'url(' + aftrload + ')');
      })
      
    } 
    
     var contact__details=document.getElementById("contact__details");
    
    
    
  if(contact__details){
      document.getElementById("contact__details").classList.add("contact--bg");
  }
  },4000)
  
      setTimeout(function(){
 var newdsrc=document.getElementById("dataSsrc");
        if(newdsrc){
 var dataSsrc=document.getElementById("dataSsrc").getAttribute('dataSsrc');
      document.getElementById("dataSsrc").setAttribute("src", dataSsrc);
        
        }
        
        
    var dsrcEl=document.getElementById("dsrc");
      if(dsrcEl){ dsrcEl.setAttribute("src", dsrcEl.getAttribute('dsrc')); }
        var payicon=document.getElementById("payicon");
        if(payicon){ payicon.style.display='block'; }
        var productVido=document.getElementById("productVido");
    
    
    
  if(productVido){ 
         var ltload3= $("#productVido iframe").attr('videodatasrc');
//           jQuery("#productVido iframe").attr('src','https://www.youtube.com/embed/'+ltload3);
  }
        
         
  },7000)
       
    
  
        
      //for our story page
        var video__banner=document.getElementById("video--banner");
        if(video__banner){
      
           $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
 
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
          
          $(window).on('resize scroll', function() {
            
            if ($('#video--banner').isInViewport()) {
              
            if($('#video--banner').hasClass('active')){}else{
    
      $('#video--banner').addClass('active');
         var attrs= $('#video--banner').attr('datasrc');  
                $('#video--banner').attr('src','https://www.youtube.com'+attrs);  
    } 
            }
}); 
          
  
        }
  
      setTimeout(function(){
       
        document.body.className += ' activebody';
        
         var styleicon=document.getElementById("styleicon");
      if(styleicon){ styleicon.setAttribute("href", styleicon.getAttribute('datahref')); }
        
        
        
      },2000)
      
      setTimeout(function(){ 
      
     var footerlast=document.getElementById("footerlast");
     if(footerlast){ footerlast.style.display='block'; }
      
       },3000)
      
   var ancklink=document.getElementById("anchoClick");
  if(ancklink){
      document.getElementById("anchoClick").addEventListener("click", function(event){
        
//   event.preventDefault()
//    window.location.href="ul#Slider-template--14332218343529__featured_collection";
//
});
  }   
}